import { Col, Row } from 'components/Ui-Kits/Grid'
import { Paragraph, Text } from 'components/Ui-Kits/Text'
import styled from 'styled-components'
import { IconText } from './IconText'
import {
  faTag,
  faCube,
  faStar,
  faMagnifyingGlass,
  faPaperclip,
  faWeightHanging,
  faRuler,
} from '@fortawesome/pro-regular-svg-icons'
import { faEarthAmericas } from '@fortawesome/pro-light-svg-icons'
import { any, bool, number, string } from 'prop-types'
import { useAppTranslation } from 'i18n/hooks'
import { theme } from 'globalStyles'
import { useParams } from 'react-router'
import { useCallback } from 'react'
import qs from 'querystring'
import { Link } from 'react-router-dom'
import { useGetTranslated } from 'hooks/useGetTranslated'
import { auctionStatuses } from 'constants/publishedProduct'

export const ItemDescription = ({
  reference,
  conditionDescription,
  size,
  weight,
  product,
  country,
  material,
  condition,
  mobile,
  auctionStatus,
  finalPrice,
}) => {
  const { t } = useAppTranslation()
  const { auctionId } = useParams()

  const getTagUrl = useCallback(id => `/auction/${auctionId}` + '?' + qs.stringify({ 'tags[]': [id] }), [auctionId])
  const getTranslated = useGetTranslated()

  const tagElements = product.tags.map(({ label, id }, index, list) => (
    <Text key={id} as={Link} to={() => getTagUrl(id)} color="primary">
      {getTranslated(label)}
      {list.length - 1 !== index && ', '}
    </Text>
  ))

  return (
    <Description mobile={mobile}>
      <Category>{getTranslated(product.category.label)}</Category>
      {!!product.tags?.length && <IconText icon={faTag} text={tagElements} color="primary" mt={2} mb={1} />}
      <StyledDiv>
        {auctionStatus === auctionStatuses.NOT_SOLD && (
          <Text color="primary" bold>
            {t('notSold')}
          </Text>
        )}
        {auctionStatus === auctionStatuses.SOLD && (
          <Text color="primary" bold>
            {t('hammerPrice')}: {finalPrice} €
          </Text>
        )}
        <Text size={0.875}>
          {t('startingPrice')}: {product?.technicalDetails?.AuctionMinimumPrice} €
        </Text>
      </StyledDiv>
      <Row>
        <Col pr={1} col={6} pb={0}>
          {material && <IconText icon={faCube} text={`${t('material')}: ${material}`} color="black" mb={0.75} />}
          {condition && <IconText icon={faStar} text={`${t('condition')}: ${condition}`} color="black" mb={0.75} />}
          {reference && (
            <IconText icon={faPaperclip} text={`${t('reference')}: ${reference}`} color="black" mb={0.75} />
          )}
        </Col>
        <Col pl={1} col={6} pb={0}>
          {country && <IconText icon={faEarthAmericas} text={`${t('country')}: ${country}`} color="black" mb={0.75} />}
          {weight && <IconText icon={faWeightHanging} text={`${t('weight')}: ${weight}`} kg color="black" mb={0.75} />}
          {size && <IconText icon={faRuler} text={`${t('size')}:${size}`} color="black" />}
        </Col>
        <Col col={12} pt={0}>
          {conditionDescription && (
            <IconText
              icon={faMagnifyingGlass}
              text={`${t('conditionDescription')}: ${conditionDescription}`}
              color="black"
              mb={0.75}
            />
          )}
        </Col>
      </Row>
      {!mobile && (
        <Paragraph mt={2} mb={2}>
          {getTranslated(product?.description)}
        </Paragraph>
      )}
      <Paragraph>SKU: {product.sku}</Paragraph>
    </Description>
  )
}

ItemDescription.propTypes = {
  reference: any,
  conditionDescription: any,
  size: any,
  weight: any,
  product: any,
  country: any,
  material: any,
  condition: any,
  mobile: bool,
  auctionStatus: string,
  finalPrice: number,
}

export const Description = styled.div`
  max-width: 100%;
  margin: 0 0 0 auto;
  margin-top: 2rem;
  display: ${({ mobile }) => (mobile ? 'block' : 'none')};

  width: 100%;

  ${theme.breakpoints.tablet} {
    display: ${({ mobile }) => (!mobile ? 'block' : 'none')};
    width: 486px;
  }
`
const Category = styled.span`
  background-color: var(--color-grey);
  color: var(--color-primary);
  font-size: 12px;
  line-height: 14px;
  padding: 6px 10px;
`
const StyledDiv = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
`
